import { Navigate, createBrowserRouter } from 'react-router-dom';
import { wrapCreateBrowserRouterV7 } from '@sentry/react';

import Checkout from './routes/Checkout';
import NotFound from './routes/NotFound';
import Authentication from './routes/Authentication';
import Page from './pages';
import CheckoutPageLayout from '../components/CheckoutPageLayout';
import { getBasename } from '../helpers/functions/navigation';
import ErrorElement from '../../shared/components/ErrorElement';
import { checkoutLoader } from './loaders/checkout';
import { authenticationLoader } from './loaders/authentication';
import { withCallbackLoader } from './loaders/callback';

const routesConfig = [
  {
    element: <CheckoutPageLayout />,
    errorElement: <ErrorElement />,
    children: [
      {
        loader: authenticationLoader,
        children: [
          {
            loader: withCallbackLoader(checkoutLoader),
            path: Page.checkout,
            element: <Checkout />,
          },
        ],
      },
      { path: Page.notFound, element: <NotFound /> },
      { path: Page.auth, element: <Authentication /> },
    ],
  },
  { path: '*', element: <Navigate to={Page.notFound} replace /> },
];

const sentryCreateBrowserRouter =
  wrapCreateBrowserRouterV7(createBrowserRouter);

const configuredRouter = sentryCreateBrowserRouter(routesConfig, {
  basename: getBasename() || '/',
});

export default configuredRouter;
